
export class TrackingState
{
id: number; 
state: string; 
}